import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class TagService extends BaseService {
	constructor() {
		super('/Tag');
	}

	public getAllByFilter(filter: TagFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getAllObjectToTagByFilter(filter: TagFilter) {
		return super.getAllByFilterBase(filter,'objectTags');
	}

	/*aktualizace tagu u componenty - obrazovky*/
	public updateReceiverTag(id: number, tags: any) {
		return super.updateBase(this._resourceName + '/receiver-tag/' + id, tags);
	}

	//aktualizace tagů u medii
	public updateContentTag(id: number, tags: any) {
		return super.updateBase(this._resourceName + '/content-tag/' + id, tags);
	}

	//aktualizace tagů u ulohy
	public updateTaskTag(id: number, tags: any) {
		return super.updateBase(this._resourceName + '/task-tag/' + id, tags);
	}

	/*aktualizace jednoho tagu ke componentam */
	public updateAllObjectTag(id: number, components: any) {
		return super.updateBase(this._resourceName + '/object-to-tag/' + id, components);
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}
}


export class TagFilter extends BaseFilter {
	constructor(idTenant?: number | null, idTag?: number | null) {
		super();
		this._idTenant = idTenant;
		this._idTag = idTag;
	}

	private _idTenant?: number | null;
	private _idTag?: number | null;

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idTag != null ? { IdTag: this._idTag } : {})
		);

		return data;
	};
}